module.exports = __webpack_public_path__ + "img/qiguanbang.8898cffc.png";